import { AbstractControl, FormGroup } from "@angular/forms";
import { ValidationConfig } from "./validationConfig";

export const Validator = {

    FormGroupValidator: {
        validate: function(formGroup: FormGroup) {
            let invalidControl = null;
            Object.keys(formGroup.controls).forEach((control) => {
                if (formGroup.controls[control].invalid && formGroup.controls[control].enabled) {
                    invalidControl = control;
                }
            })
            return invalidControl;
        }
    },

    InputValidator: {
        email: {
            validate: function(email: string) {
                return (email.match(ValidationConfig.regexes.email)) ? true : false;
            }
        },
        password: {
            confirmPasswords: function(password: string, confirmPassword: string) {
                if (password != confirmPassword) {
                    return false;
                }
                return true;
            }
        }

    },

    ReactiveFormsValidators: {
        passwordValidator: function(control: AbstractControl): {[key : string]: boolean} | null {
            const value = <string> control.value;
            if (!value) return {'passwordValidator': false};
            if ( value.search(/\d/) < 0 || 
                 value.search(/[a-zа-я]/) < 0 || 
                 value.search(/[A-ZА-Я]/) < 0 || 
                 value.search(/\W/) < 0){
              return {'passwordValidator': false};
            }
            return null;
        }
    },

    TypeValidators: {
        objectValidator: {
            isObjectEmpty: function(obj: object) {
                if (!obj) {
                    return false;
                }
                return !Object.keys(obj).length;
            }
        }
    },

    Images: {
        allowedImages: {
            validate: function(extension: string) {
                return ValidationConfig.images.allowedImageExtensions.indexOf(extension.toLowerCase()) > -1;
            }
        },
    
        maxSizeOfImage: {
            validate: function(imageSize: number) {
                if (imageSize > ValidationConfig.images.maxSizeOfImage) {
                    return false;
                }
                return true;
            }
        },
    }
}